var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeconnexion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.2 27",
    style: {
      enableBackground: "new 0 0 37.2 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M4.6,14.9h19.5c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3H4.7l3.7-3.7c0.5-0.5,0.5-1.3,0-1.8 c-0.5-0.5-1.3-0.5-1.8,0l-5.9,6c-0.5,0.5-0.5,1.3,0,1.8l5.9,6c0.3,0.3,0.6,0.4,0.9,0.4c0.3,0,0.7-0.1,0.9-0.4 c0.5-0.5,0.5-1.3,0-1.8L4.6,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M33.1,4.1c-2.5-2.5-5.8-3.9-9.4-3.9c-3.5,0-6.9,1.4-9.4,3.9c-0.3,0.3-0.5,0.6-0.5,0.9c0,0.3,0.1,0.6,0.3,0.8 c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.2,0.9-0.5c2.1-2.1,4.8-3.2,7.8-3.2c2.9,0,5.7,1.1,7.8,3.2c4.3,4.3,4.3,11.3,0,15.5h0 c-2.1,2.1-4.8,3.2-7.8,3.2c-2.9,0-5.7-1.1-7.8-3.2c-0.3-0.3-0.6-0.5-0.9-0.5c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8 c0,0.3,0.2,0.6,0.5,0.9c2.5,2.5,5.8,3.9,9.4,3.9c3.5,0,6.9-1.4,9.4-3.9C38.3,17.7,38.3,9.3,33.1,4.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeconnexion);
export default __webpack_public_path__ + "static/media/Deconnexion.24a0f1cb.svg";
export { ForwardRef as ReactComponent };